import { render, staticRenderFns } from "./SupportAuthorization.vue?vue&type=template&id=24536388&scoped=true&lang=pug&"
import script from "./SupportAuthorization.vue?vue&type=script&lang=js&"
export * from "./SupportAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./SupportAuthorization.vue?vue&type=style&index=0&id=24536388&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24536388",
  null
  
)

export default component.exports